import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './components/layout/AppLayout';

import LoginPage     from './pages/LoginPage';
import SignupPage    from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage    from './pages/SearchPage';
import CleanupPage   from './pages/CleanupPage';
import CategoriesPage from './pages/CategoriesPage';
import TrashPage      from './pages/TrashPage';
import SettingsPage   from './pages/SettingsPage';
import AccountPage    from './pages/AccountPage';
import SummaryPage    from './pages/SummaryPage';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"  element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignupPage /></PublicRoute>} />

      <Route path="/" element={
        <PrivateRoute><AppLayout><DashboardPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/categories" element={
        <PrivateRoute><AppLayout><CategoriesPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/categories/:categoryId" element={
        <PrivateRoute><AppLayout><CategoriesPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/folders" element={
        <Navigate to="/categories" replace />
      }/>
      <Route path="/folders/:categoryId" element={
        <PrivateRoute><AppLayout><CategoriesPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/cleanup" element={
        <PrivateRoute><AppLayout><CleanupPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/summary" element={
        <PrivateRoute><AppLayout><SummaryPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/trash" element={
        <PrivateRoute><AppLayout><TrashPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/search" element={
        <PrivateRoute><AppLayout><SearchPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/settings" element={
        <PrivateRoute><AppLayout><SettingsPage /></AppLayout></PrivateRoute>
      }/>
      <Route path="/account" element={
        <PrivateRoute><AppLayout><AccountPage /></AppLayout></PrivateRoute>
      }/>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          toastStyle={{
            background: 'var(--surface-1)',
            border: '1px solid var(--border-strong)',
            color: 'var(--text-primary)',
            boxShadow: 'var(--shadow)'
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
